
import { Routes, Route, useLocation } from 'react-router-dom';
import PaymentOptions from './pages/PaymentOptions';
import GatewayRedirect from './pages/GatewayRedirect';
import PaymentResult from './pages/PaymentResult';

export default function PaymentRoutes() {

  return (
    <Routes>
      <Route path="/options" element={<PaymentOptions />} />
      <Route path="/gateway" element={<GatewayRedirect />} />
      <Route path="/result" element={<PaymentResult />} />
    </Routes>
  );
}
